import { appConfig } from '../../utils/appConfig';
import useTechnicalErrorMessage from '../common/hooks/useTechnicalErrorMessage';
import { SocialResponse } from '../common/interfaces/user';
//@ts-ignore
import AppleSignin from 'react-apple-signin-auth';

interface SignInAppleProps {
	appleSignIn: any;
}

declare global {
	interface Window {
		AppleID: any;
	}
}

const SignInApple = ({ appleSignIn }: SignInAppleProps) => {
	const [showTechnicalErrorMessage] = useTechnicalErrorMessage();

	const handleAppleRespone = (appleSuccessResponse: any) => {
		const user = {
			firstName: '',
			lastName: '',
			email: ''
		};

		if (appleSuccessResponse.user) {
			user.email = appleSuccessResponse.user.email ? appleSuccessResponse.user.email : '';

			if (appleSuccessResponse.user.name) {
				user.firstName = appleSuccessResponse.user.name.firstName;
				user.lastName = appleSuccessResponse.user.name.lastName;
			}
		}

		const appleResponse: SocialResponse = {
			firstName: user.firstName,
			lastName: user.lastName,
			email: user.email ? (user.email.includes('privaterelay.appleid.com') ? '' : user.email) : '',
			token: appleSuccessResponse.authorization && appleSuccessResponse.authorization.code,
			type: 'apple'
		};

		appleSignIn(appleResponse);
	};

	const handleAppleError = (appleErroResponse: any) => {
		if (appleErroResponse.error !== 'popup_closed_by_user') {
			showTechnicalErrorMessage();
		}
	};

	return (
		<AppleSignin
			authOptions={{
				clientId: appConfig.appleClientId,
				scope: 'email name',
				redirectURI: appConfig.appleRedirectURI,
				state: '',
				nonce: 'nonce',
				usePopup: true
			}}
			onSuccess={handleAppleRespone}
			onError={handleAppleError}
			render={(props: any) => (
				<button
					{...props}
					className="btn-social apple-social"
					aria-label="Sign in with Apple opens in new window">
					<img src="./images/buttons-social-apple.png" className="icon-social" alt="" />
				</button>
			)}
			uiType={'light'}
		/>
	);
};

export default SignInApple;
